// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__176Ir","buttons":"SendReceipts_buttons__2VlUE","email":"SendReceipts_email__2QfqT","bookApptTitle":"SendReceipts_bookApptTitle__22RsM"};